import CrudService from '../core/crud-service';

export default class UsersService extends CrudService {
  static override route = 'users';
}
